import {Data} from "../Data";

export class Assignment{
	constructor(
		public id: number,
		public material: Data.Material
	){}
}

export class Rule{
	constructor(
		public selector: string,
		public material: Data.Material
	){}
}



// WEBPACK FOOTER //
// ./src/script/app3D/utils/General.ts